/**
 * Wire-level constants shared by client and server so we never have magic
 * strings for room join options or reconnection state.
 */
export const ROOM_OPTIONS_KEYS = {
    MODE: "mode",
    USERNAME: "username",
    ACCESS_TOKEN: "accessToken",
    INVITE_CODE: "inviteCode",
    RECONNECTION_TOKEN: "reconnectionToken",
};
export const RECONNECT_GRACE_MS = 20_000;
/** Recap window after a match ends: casual rooms reset to the lobby,
 *  ranked clients return to the menu. Shared so the client countdown
 *  can't drift away from the server's timer. */
export const POST_MATCH_RECAP_MS = 7_000;
export const MESSAGE_RATE_LIMIT = {
    /** max messages per rolling window */
    COUNT: 40,
    WINDOW_MS: 1000,
};
export const CHAT_RATE_LIMIT = {
    COUNT: 4,
    WINDOW_MS: 5_000,
};
//# sourceMappingURL=protocol.js.map